import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger)

const SlideUp = ({
                   children,
                   duration = 0.8,
                   delay = 0,
                   ease = "power2.out",
                   start = "top 85%",
                   end = "top 30%",
                   yOffset = 50,
                   once = false,
                   className = "",
                   style = {},
                   as: Tag = 'div'
                 }) => {
  const elementRef = useRef(null)

  useEffect(() => {
    const el = elementRef.current
    if (!el) return

    gsap.set(el, { opacity: 0, y: yOffset })

    const animation = gsap.to(el, {
      y: 0,
      opacity: 1,
      duration,
      delay,
      ease,
      scrollTrigger: {
        trigger: el,
        start,
        end,
        toggleActions: once ? "play none none none" : "play none none reverse",
      }
    })

    return () => {
      animation.scrollTrigger?.kill()
    }
  }, [duration, delay, ease, start, end, yOffset, once])

  return (
    <Tag
      ref={elementRef}
      className={className}
      style={style}
    >
      {children}
    </Tag>
  )
}

export default SlideUp
